export const STOP_CATEGORIES = [
  { id: "nome", label: "Nome", emoji: "👤" },
  { id: "pch", label: "PCH", descricao: "Partes do Corpo Humano", emoji: "🫀" },
  { id: "animal", label: "Animal", emoji: "🐾" },
  { id: "cor", label: "Cor", emoji: "🎨" },
  { id: "fruta", label: "Fruta/Comida", emoji: "🍎" },
  { id: "objeto", label: "Objeto", emoji: "📦" },
  { id: "profissao", label: "Profissão", emoji: "💼" },
  { id: "pais", label: "País/Cidade", emoji: "🌍" },
  { id: "marca", label: "Marca", emoji: "🏷️" },
  { id: "famoso", label: "Famoso", emoji: "⭐" },
  { id: "filme-serie", label: "Filme/Série/Jogo", emoji: "🎬" },
];
